import { render } from "./dailyReport.vue?vue&type=template&id=28fa8437&scoped=true"
import script from "./dailyReport.vue?vue&type=script&lang=js"
export * from "./dailyReport.vue?vue&type=script&lang=js"

import "./dailyReport.vue?vue&type=style&index=0&id=28fa8437&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fa8437"]])

export default __exports__